import React, { useState } from 'react';
import { StarIcon } from 'lucide-react';
interface ProductTabsProps {
  product: {
    description: string;
    rating: number;
    reviewCount: number;
  };
}
export function ProductTabs({
  product
}: ProductTabsProps) {
  const [activeTab, setActiveTab] = useState('about');
  const tabs = [{
    id: 'about',
    label: 'About Product'
  }, {
    id: 'details',
    label: 'Details'
  }, {
    id: 'rating',
    label: 'Product Rating'
  }, {
    id: 'reviews',
    label: 'Product Reviews'
  }];
  return <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-5140" data-mp="3i2dqwd8ygqpe">
      {/* Tab Headers */}
      <div className="border-b border-gray-200" data-id="element-5141" data-mp="39422mhvka504">
        <div className="flex overflow-x-auto scrollbar-hide" data-id="element-5142" data-mp="394v0etcjlk64">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex-shrink-0 px-6 py-4 text-sm font-medium transition-colors ${activeTab === tab.id ? 'text-[#1E2B55] border-b-2 border-[#1E2B55]' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-5143" data-mp="12ex7r4ciel2i">
              {tab.label}
            </button>)}
        </div>
      </div>
      {/* Tab Content */}
      <div className="p-6" data-id="element-5144" data-mp="3hyafatw0nhae">
        {activeTab === 'about' && <div data-id="element-5145" data-mp="3d10i2s2dy1c0">
            <h4 className="text-lg font-bold text-gray-900 mb-4" data-id="element-5146" data-mp="3d0iq47mra99w">
              About This Product
            </h4>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-5147" data-mp="2paoe1sa9goqp">
              {product.description}
            </p>
            <p className="text-gray-700 leading-relaxed" data-id="element-5148" data-mp="2lb5sqvej2bnc">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
              quam velit, vulputate eu pharetra nec, mattis ac neque. Duis
              vulputate commodo lectus, ac blandit elit tincidunt id. Sed
              rhoncus, tortor sed eleifend tristique, tortor mauris molestie
              elit, et lacinia ipsum quam nec dui.
            </p>
            <button className="mt-4 text-[#1E2B55] font-medium hover:underline" data-id="element-5149" data-mp="hkhl6jzsvxe8">
              Read More
            </button>
          </div>}
        {activeTab === 'details' && <div data-id="element-5150" data-mp="qkw9ls829sly">
            <h4 className="text-lg font-bold text-gray-900 mb-4" data-id="element-5151" data-mp="qkd275g1emm6">
              Product Details
            </h4>
            <div className="space-y-3" data-id="element-5152" data-mp="viodlklzd56i">
              <div className="flex" data-id="element-5153" data-mp="vhmxv2u0ruig">
                <span className="w-1/3 text-sm font-medium text-gray-600" data-id="element-5154" data-mp="3u1v7b54fdfiw">
                  Brand:
                </span>
                <span className="text-sm text-gray-900" data-id="element-5155" data-mp="2vtuar0wgbum">COSRX</span>
              </div>
              <div className="flex" data-id="element-5156" data-mp="7tvfpilssn99">
                <span className="w-1/3 text-sm font-medium text-gray-600" data-id="element-5157" data-mp="7su1545kpims">
                  Size:
                </span>
                <span className="text-sm text-gray-900" data-id="element-5158" data-mp="3bavefstt7lkc">100ml</span>
              </div>
              <div className="flex" data-id="element-5159" data-mp="3b8r9r8o36ij0">
                <span className="w-1/3 text-sm font-medium text-gray-600" data-id="element-5160" data-mp="3g9ez7pwo2rb4">
                  Skin Type:
                </span>
                <span className="text-sm text-gray-900" data-id="element-5161" data-mp="38p4ia26cso93">
                  All Skin Types, Dry Skin
                </span>
              </div>
              <div className="flex" data-id="element-5162" data-mp="33phzzebo4htf">
                <span className="w-1/3 text-sm font-medium text-gray-600" data-id="element-5163" data-mp="2yrgkf3dgb0mp">
                  Key Ingredients:
                </span>
                <span className="text-sm text-gray-900" data-id="element-5164" data-mp="2tswwwyj7lgs8">
                  Snail Secretion Filtrate
                </span>
              </div>
              <div className="flex" data-id="element-5165" data-mp="2l14pkwphenrv">
                <span className="w-1/3 text-sm font-medium text-gray-600" data-id="element-5166" data-mp="2l0337w30meuu">
                  Country of Origin:
                </span>
                <span className="text-sm text-gray-900" data-id="element-5167" data-mp="2fznnwyz6axa8">South Korea</span>
              </div>
            </div>
          </div>}
        {activeTab === 'rating' && <div data-id="element-5168" data-mp="2632m0miga2am">
            <h4 className="text-lg font-bold text-gray-900 mb-4" data-id="element-5169" data-mp="265os0hpp09qq">
              Customer Ratings
            </h4>
            <div className="flex items-center gap-6 mb-6" data-id="element-5170" data-mp="224d1m9yzvkhh">
              <div className="text-center" data-id="element-5171" data-mp="2qty1zbjhjqmu">
                <div className="text-5xl font-bold text-gray-900 mb-2" data-id="element-5172" data-mp="2vrq571pkyz6c">
                  {product.rating}
                </div>
                <div className="flex items-center justify-center mb-1" data-id="element-5173" data-mp="2i14ljasayl7e">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-5 h-5 ${i < Math.floor(product.rating) ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} data-id="element-5174" data-mp="2m0lonxk9b69e" data-mpi={i} />)}
                </div>
                <p className="text-sm text-gray-600" data-id="element-5175" data-mp="1z1qo2ivd6sc5">
                  {product.reviewCount} reviews
                </p>
              </div>
              <div className="flex-1" data-id="element-5176" data-mp="233u0patrs2z0">
                {[5, 4, 3, 2, 1].map(stars => <div key={stars} className="flex items-center gap-2 mb-2" data-id="element-5177" data-mp="3tgje82dhaqwp">
                    <span className="text-sm text-gray-600 w-8" data-id="element-5178" data-mp="1c7edmktow8v">{stars} ★</span>
                    <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-5179" data-mp="1ltq5uffud8pk">
                      <div className="h-full bg-yellow-400" style={{
                  width: `${stars === 5 ? 70 : stars === 4 ? 20 : stars === 3 ? 5 : stars === 2 ? 3 : 2}%`
                }} data-id="element-5180" data-mp="1hs4vb0qs56ij" />
                    </div>
                    <span className="text-sm text-gray-600 w-12" data-id="element-5181" data-mp="25hh1rsuq30h5">
                      {stars === 5 ? 70 : stars === 4 ? 20 : stars === 3 ? 5 : stars === 2 ? 3 : 2}
                      %
                    </span>
                  </div>)}
              </div>
            </div>
          </div>}
        {activeTab === 'reviews' && <div data-id="element-5182" data-mp="f7e5xtrmc8fe">
            <h4 className="text-lg font-bold text-gray-900 mb-4" data-id="element-5183" data-mp="2f7j1w6mxxvkc">
              Customer Reviews
            </h4>
            <div className="space-y-4" data-id="element-5184" data-mp="2k6dws6y6nakt">
              {[1, 2, 3].map(review => <div key={review} className="border-b border-gray-200 pb-4" data-id="element-5185" data-mp="2p5qfqglxnxi4">
                  <div className="flex items-center gap-2 mb-2" data-id="element-5186" data-mp="2p7th1wsjdd25">
                    <div className="flex" data-id="element-5187" data-mp="2t83kp2suvrdu">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-5188" data-mp="2y5luswim0cnf" data-mpi={i} />)}
                    </div>
                    <span className="text-sm font-medium text-gray-900" data-id="element-5189" data-mp="37x005kx8s6oh">
                      Verified Purchase
                    </span>
                  </div>
                  <p className="text-sm text-gray-700 mb-2" data-id="element-5190" data-mp="3gxo75vo7x6rv">
                    Amazing product! My skin feels so much better after using
                    this essence. Highly recommend!
                  </p>
                  <div className="flex items-center gap-2 text-xs text-gray-500" data-id="element-5191" data-mp="1a9ff47zyt4uq">
                    <span data-id="element-5192" data-mp="1599s554n46iz">Sarah M.</span>
                    <span data-id="element-5193" data-mp="15889aehdufqp">•</span>
                    <span data-id="element-5194" data-mp="117o9f35fcy0v">2 weeks ago</span>
                  </div>
                </div>)}
            </div>
            <button className="mt-4 text-[#1E2B55] font-medium hover:underline" data-id="element-5195" data-mp="w9msoovh1ask">
              View All Reviews
            </button>
          </div>}
      </div>
    </div>;
}